import script from "./ExportBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportBtn.vue?vue&type=script&lang=ts&setup=true"

import "./ExportBtn.vue?vue&type=style&index=0&id=8c2ba4c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c2ba4c6"]])

export default __exports__